import _ from 'lodash'

function convertSubGroup (subGroup, seperator = '>') {
  return subGroup.map(({ count, name }) => {
    const [id, subGroupName] = _.split(name, seperator)
    return {
      id, name: subGroupName, count
    }
  })
}

/**
 * 구분자가 포함된 문자열 배열을 id, value, count를 가진 object 배열로 변환
 * @param {object[]} filterList
 * @param {string} seperator
 * @returns {{id: string, name: string, count: number, ?parent: string}[]}
 */
export const convertIds = (filterList, seperator = '>') => {
  return _.chain(filterList)
    .map(({ ids, values }) => {
      return _.chain(ids)
        .map((_item, i) => {
          const arr = _.nth(ids, i).split(seperator)
          let id, parent
          if (arr.length === 2) {
            id = _.head(arr)
          } else if (arr.length > 2) {
            id = _.nth(arr, -2)
            parent = _.nth(arr, -3)
          }
          let name = _.last(arr)
          let kind

          const nameKind = name.split('_')
          if (nameKind.length === 2) {
            name = _(nameKind).head()
            kind = name + ' - ' + _(nameKind).last()
          }

          const value = values[i]

          let subGroup
          if (_.isObject(value)) {
            subGroup = convertSubGroup(value.subGroup, seperator)
          }

          return {
            id,
            name,
            kind,
            value: subGroup ? value.count : value,
            parent,
            subGroup
          }
        })
        .filter(({ id }) => _.size(id) > 0 && id !== seperator)
        .thru((items) => {
          const pdPrcRangeItems = _.filter(items, item => item.name === item.id)
          const otherItems = _.filter(items, item => item.name !== item.id)
          return _.concat(_.sortBy(pdPrcRangeItems, ({ name }) => parseInt(name)), otherItems)
        })
        .value()
    })
    .value()
}

export function convertFilters (filters) {
  const result = {
    largeExhCtgrNo: '',
    middleExhCtgrNo: '',
    smallExhCtgrNo: '',
    attrItemCd: '',
    brndCd: '',
    dvrTy: '',
    goodsType: '',
    revwStsc: '',
    pdPrcRange: '',
    tOrdr: ''
  }

  _.chain(filters)
    .groupBy('type')
    .forEach(function (value, key) {
      switch (key) {
        case 'lcl_cd':
          result.largeExhCtgrNo = _.head(value).id
          break
        case 'mcl_cd':
          result.largeExhCtgrNo = _.head(value).category[0]
          result.middleExhCtgrNo = _.head(value).category[1]
          break
        case 'scl_cd':
          result.largeExhCtgrNo = _.head(value).category[0]
          result.middleExhCtgrNo = _.head(value).category[1]
          result.smallExhCtgrNo = _.head(value).category[2]
          break
        case 'attrItemCd':
          result.attrItemCd = value
            .map((v) => {
              return v.id
            }).join(',')
          break
        case 'brndCd':
          result.brndCd = value
            .map((v) => {
              return v.id
            }).join(',')
          break
        case 'dvrTy':
          result.dvrTy = value
            .map((v) => {
              return v.id
            }).join(',')
          break
        case 'goodsType':
          result.goodsType = value
            .map((v) => {
              return v.id
            }).join(',')
          break
        case 'revwStsc':
          result.revwStsc = value
            .map((v) => {
              return v.id
            }).join(',')
          break
        case 'pdPrcRange':
          result.pdPrcRange = value
            .map((v) => {
              return v.id
            }).join(',')
          break
        case 'tOrdr':
          result.tOrdr = value
            .map((v) => {
              return v.id
            }).join(',')
          break
      }
    })
    .value()

  return result
}

/**
 * API 데이터(대, 중, 소)를 트리 구조 '대 > 중 > 소'로 변경
 */
export const makeCategoryTree = ({ major, medium, small }) => {
  const majors = _.groupBy(major, 'id')
  const mediums = _.groupBy(medium, 'id')

  return _
    .chain(small)
    .groupBy('parent')
    .transform((mediumResult, mediumChildren, mediumKey) => {
      const {
        name: mediumName,
        parent: mediumParent,
        type: mediumType,
        value: mediumCount,
      } = _.head(mediums[mediumKey])

      mediumResult.push({
        id: mediumKey,
        label: mediumName,
        parent: mediumParent,
        type: mediumType,
        value: mediumCount,
        category: [mediumParent, mediumKey],
        children: mediumChildren
          .map(({
            id: smallId,
            name: smallName,
            type: smallType,
            value: smallCount,
            parent: smallParent,
          }) => ({
            id: smallId,
            label: smallName,
            type: smallType,
            value: smallCount,
            category: [mediumParent, smallParent, smallId],
          })),
      })
    }, [])
    .groupBy('parent')
    .transform((majorResult, majorChildren, majorKey) => {
      const {
        name: majorName,
        type: majorType,
        value: majorCount,
      } = _.head(majors[majorKey])

      majorResult.push({
        id: majorKey,
        label: majorName,
        type: majorType,
        value: majorCount,
        category: [majorKey],
        children: majorChildren,
      })
    }, [])
    .value()
}

/**
 * 카테고리가 선택된 상태인가?
 */
export const isSelectedCategory = selectedList => _.chain(selectedList).has('onlyOne').value()

/**
 * 속성이 보여질 타입
 */
export const isShownPropertyType = type => // type === 'mcl_cd' ||
  type === 'scl_cd'

/**
 * 카테고리 타입
 */
export const isCategoryType = type => type === 'scl_cd' || type === 'mcl_cd' || type === 'lcl_cd'

/**
 * 속성이 보여질지 확인
 */
export const checkShownProperty = value => _.chain(value)
  .filter(v => isShownPropertyType(v.type)).size().value() > 0

export const addFilterType = (list, type) => _(list)
  .map(item => ({
    type,
    ...item,
  }))
  .value()

/**
 * 필터와 상품을 모두 업데이트 해야 하는가?
 */
export const isFullRefresh = filterCheck => _.size(filterCheck) === 0 ||
  (_.size(filterCheck) === 1 &&
   _.chain(filterCheck).filter(chk => isCategoryType(chk.type)).size() > 0)

export const sortByCount = list => _(list)
  .sort(({ value: aCount }, { value: bCount }) => bCount - aCount)
  .value()

/**
 * 항목 리스트에 항목이 존재하는가?
 * @argument list 필터 항목 리스트
 * @return boolean
 */
export const isHaveItem = list => _.chain(list).filter(item => item !== '>').size().value() > 0

export const keepAllCategory = (oldList, newList) => {
  let result = newList

  if (!_.isEqual(oldList, newList)) {
    if (oldList && _.size(oldList) > 0) {
      result = _(newList)
        .map((item, idx) =>
          (idx < 1 || idx > 3) // 대,중,소 카테고리
            ? item
            : oldList[idx]
        )
        .value()
    }
  }

  return result
}

export const recentlySearchTerms = () => JSON.parse(localStorage.getItem('recentlySearchTerms'))
